<template>
    <el-dialog title="AI互动" :close-on-press-escape="false" @close="closeDialog" :close-on-click-modal="false" :visible.sync="dialogVisible"
        width="140rem">
        <!-- AI智能书写 -->
        <div class="main">
            <div class="header">
                <div class="header-title"><i class="el-icon-question"></i> 问题分析助手</div>
                <div class="header-desc">输入建筑相关问题，AI智能分析并给出权威解答。</div>
            </div>
            <div class="content-area" style="position: relative;">
                <div class="right">
                    <div class="problem" style="width: 25rem;border-right: 1px solid #ccc;background: #f2f5f6;">
                        <div class="btn-button" @click="addChat"><i class="el-icon-edit"></i>开启新对话</div>
                        <div class="scroll-box" style="height: calc(100% - 2.25rem);overflow: auto;margin-top: 2rem;">
                            <div class="add-btn-list">
                                <div class="add-item"
                                    style="white-space: nowrap;overflow: hidden;display: flex;justify-content: space-between;box-sizing: border-box;"
                                    :class="item.chatId == chatId ? 'add-item2' : ''"
                                    v-for="(item, index) in problemList" :key="index" @click="changeChat(item)">
                                    <div v-if="replayId != item.chatId" style="width: 80%;overflow: hidden;">
                                        {{ item.messageText }}</div>
                                    <el-input v-if="replayId == item.chatId" @blur="renameChat(item)" type="text"
                                        :ref="item.chatId" autofocus=true v-model="item.messageText"
                                        placeholder=""></el-input>
                                    <el-dropdown class="no-display" :class="item.chatId == chatId ? 'visible-chat' : ''"
                                        trigger="click" @click.native.stop>
                                        <span class="el-dropdown-link">
                                            <i class="el-icon-more"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="del(item)">删除</el-dropdown-item>
                                            <el-dropdown-item @click.native="rename(item)">重命名</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="answer">
                        <div class="Dialogue" ref="Dialogue" :class="suggestShow ? 'height-active' : ''">
                            <div class="Questions-big-title" v-if="answerList.length == 0">
                                <div>
                                    欢迎来到问题分析助手
                                </div>
                                <div class="Questions-big-list">
                                    <div class="content">
                                        基于建筑领域知识库与因果推理引擎，构建面向工程实践与教学场景的智能问答系统。支持文本、语音、图纸截图等多形式输入，自动识别问题类型(如设计缺陷、施工工艺冲突、规范合规性判断)。
                                    </div>
                                    <div class="content">
                                        <div v-for="(item, index) in list2" :key="index" @click="startAnswer(item)">{{
                                            item }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="Question-and-Answer">
                                <div v-for="(item, index) in answerList" :key="index">
                                    <div class="Question-and-Answer-item">
                                        <i style="font-size: 1.5rem;margin-right: 1rem;margin-top:2.3rem;"
                                            v-if="item.role == 'user'" class="el-icon-s-custom"></i>
                                        <div v-if="item.role == 'user'" class="content-answer"
                                            style="font-weight:600;margin-top: 1rem;">
                                            <div style="display: flex;">
                                                <i v-if="item.fileName" class="el-icon-document"
                                                    style="font-size: 1rem;"></i>{{ item.fileName }}
                                                <img v-if="item.imgName" style="width: 4rem;height:4rem"
                                                    @click="openImg(item)" :src="item.imgPath" alt="">
                                                <i v-if="item.videoName" class="el-icon-video-camera"
                                                    style="font-size:1rem;cursor:pointer"></i>{{ item.videoName }}
                                            </div>
                                            <span>{{ item.messageText }}</span>
                                        </div>
                                    </div>
                                    <div v-if="item.role == 'assistant'" class="Question-and-Answer-item"
                                        style="margin-bottom: 2rem;flex-direction: column;"
                                        :class="item.role == 'assistant' ? 'item-right' : ''">
                                        <!-- <i class="el-icon-loading"></i> -->
                                        <div v-if="loadding2 && index == nextId - 1" class="loader-box">
                                            <div class="loader"></div>
                                        </div>
                                        <!-- <img v-else style="width: 2rem;height: 2rem;margin-top: 0rem;margin-right: 1rem;"
                                        src="../../static/icon.png" alt=""> -->
                                        <el-card class="box-card">
                                            <div class="content-answer" v-if="loadding && index == nextId - 1">
                                                <div class="loading-dots">
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                </div>
                                            </div>
                                            <div class="content-answer "
                                                v-if="!loadding && index == nextId - 1 || index != nextId - 1">
                                                <div class="known" @click="openDrawer(item.webResults)"
                                                    v-if="item.webResults && item.webResults.length > 0">
                                                    已联网搜索{{ item.webResults.length }}个网页></div>
                                                <div class="net known" @click="openDrawer(item.vectorResults)"
                                                    v-if="item.vectorResults && item.vectorResults.length > 0">
                                                    知识库搜索{{ item.vectorResults.length }}条记录></div>
                                                <div v-html="item.messageText">
                                                </div>
                                                <img @click="openImg(item)"
                                                    style="width: 4rem;height: 4rem;margin-top: 0rem;margin-right: 1rem;cursor: pointer;"
                                                    :src="item.rowImgUrl" v-if="item.rowImgUrl" alt="">
                                            </div>
                                        </el-card>
                                        <div class="icon-list">
                                            <el-tooltip effect="light" placement="top" content="重新生成">
                                                <i class="el-icon-refresh" @click="refresh(index)"></i></el-tooltip>
                                            <el-tooltip effect="light" placement="top" content="复制">
                                                <i class="el-icon-document-copy examSrc" @click="copy(item)"
                                                    :data-clipboard-text="item.messageText"></i></el-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <el-backtop :bottom="20"> -->

                            <!-- </el-backtop> -->
                            <div class="stop-answer" v-if="stopResp">
                                <el-button type="info" @click="stopAnswer" plain
                                    icon="el-icon-switch-button">停止响应</el-button>
                            </div>

                        </div>
                        <div class="Questions" style="bottom: 1.25rem"
                            :class="answerList.length > 0 ? 'Questions-bottom' : ''">
                            <div class="Questions-suggest" v-if="configList.length > 0 && !suggestShow">
                                <div @click="changeSuggest(item)" v-for="(item, index) in configList" :key="index"><i
                                        class="el-icon-edit"></i>{{ item.title }}</div>
                            </div>
                            <div v-if="suggestShow" class="Questions-suggest-detail">
                                <div class="suggest-detail-title">
                                    <div>
                                        <i class="el-icon-edit"></i>{{ suggestInfo.title }}
                                    </div>
                                    <div style="font-size: 1.5rem;cursor: pointer;display: flex;align-items: center;">
                                        <div style="font-size: 1rem;padding-right: 0.8rem;"
                                            v-if="suggestInfo.type == '5'" @click="addCommand">创建指令</div>
                                        <div style="margin-top: -0.5rem;" @click=" clearRecord">x</div>
                                    </div>
                                </div>
                                <div class="suggest-content" style="flex-direction: column;overflow: auto;height:4rem"
                                    v-if="suggestInfo.type == '5'">
                                    <!-- <div v-for="item in commandList">{{item.instructionsTitle}}</div> -->
                                    <div class="file" style="width: 100%;justify-content: space-between;display: flex;"
                                        @click="textarea = item.instructionsTitle; suggestShow = false"
                                        v-for="(item, index) in commandList" :key="index">
                                        <div>{{ item.instructionsTitle }}</div>
                                        <div><i class="el-icon-edit" @click.stop="editCommand(item)"
                                                style="margin-right: 0.5rem;cursor: pointer;"></i> <i
                                                @click.stop="delCommand(item)" class="el-icon-circle-close"
                                                style="margin-left: 0.5rem;cursor: pointer;"></i></div>
                                    </div>
                                </div>
                                <div class="suggest-content" v-if="suggestInfo.type != '5'">
                                    <div class="suggest-item" :class="imgType == item.type ? 'suggest-item-active' : ''"
                                        @click="changeImg(item)" v-for="(item, index) in suggestInfo.children"
                                        :key="index">
                                        <span><i class="el-icon-edit-outline"></i>{{ item.title }}</span>
                                    </div>
                                </div>

                            </div>
                            <div v-if="upHeightShow" @click="toDown" class="upHeightShow">
                                <!-- UP -->
                                <i class="el-icon-arrow-down"></i>
                            </div>
                            <!-- <div class="Questions-tile" v-if="answerList.length==0">欢迎来到真道智享问答</div> -->
                            <div class="file" v-if="info.filePath">
                                <i class="el-icon-document"></i>{{ info.fileName }} <i @click="clearFile"
                                    class="el-icon-circle-close" style="margin-left: 0.5rem;cursor: pointer;"></i>

                            </div>
                            <div class="file" v-if="info.imgPath" @click="openImg(info)">
                                <!-- <i
                                    class="el-icon-picture-outline"></i>{{info.imgName}} <i @click="clearFile"
                                    class="el-icon-circle-close" style="margin-left: 0.5rem;cursor: pointer;"></i> -->
                                <img :src="info.imgPath" alt=""><i @click="clearFile" class="el-icon-circle-close"
                                    style="margin-left: 0.5rem;cursor: pointer;"></i>
                            </div>
                            <div class="file" v-if="info.videoPath" @click="openVideo(info.videoPath)"><i
                                    class="el-icon-video-camera"></i>{{ info.videoName }} <i @click="clearFile"
                                    class="el-icon-circle-close" style="margin-left: 0.5rem;cursor: pointer;"></i></div>
                            <!-- 弹框展示 -->
                            <div v-if="suggestShow && imgType && imgType != '3.2' && imgType != '3.1' && promptList.length > 1"
                                class="textarea-suggestShow">
                                <template v-for="(item, index) in promptList">
                                    <span v-if="!item.placeholder">
                                        {{ item.str }}
                                    </span>
                                    <div v-if="item.placeholder" :data-placeholder="item.placeholder"
                                        @keydown.enter="submitEvent" class="auto-width-input" contenteditable="true"
                                        @input="handleInput($event, index)" :style="{ minWidth: '2rem' }"></div>
                                    <span v-if="item.placeholder && item.str">
                                        {{ item.str }}
                                    </span>
                                </template>
                            </div>
                            <el-input v-if="!suggestShow || imgType == '3.2' || imgType == '3.1'" autofocus autosize
                                type="textarea" :placeholder="placeholder" :rows="8" v-model="textarea"
                                @keyup.enter.native="submitEvent" suffix-icon="el-icon-s-promotion">
                            </el-input>
                            <div class="think-type" v-if="!suggestShow">
                                <el-button :type="model.online ? 'primary' : ''" @click="model.online = !model.online"
                                    icon="el-icon-orange">联网搜索</el-button>
                                <el-button :type="model.knowledgeBase ? 'primary' : ''"
                                    @click="model.knowledgeBase = !model.knowledgeBase"
                                    icon="el-icon-reading">知识库搜索</el-button>
                            </div>
                            <div class="think-type2">
                                <el-progress v-if="fileObj.status == 'pending'"
                                    style="width: 20rem;margin-left: 1.5rem;"
                                    :percentage="currentPercent"></el-progress>
                                <el-upload class="avatar-uploader" action="#" :show-file-list="false"
                                    :auto-upload="false" :on-change="handleFile">
                                    <el-tooltip effect="light" placement="top" content="文件上传"><i
                                            class="el-icon-upload"></i></el-tooltip>

                                </el-upload>
                                <el-upload class="avatar-uploader" action="#" :show-file-list="false"
                                    :auto-upload="false" :on-change="handleImg">
                                    <el-tooltip effect="light" placement="top" content="图片上传"> <i
                                            class="el-icon-picture-outline"></i></el-tooltip>

                                </el-upload>
                                <el-upload class="avatar-uploader" action="#" :show-file-list="false"
                                    :auto-upload="false" :on-change="handleVideo">
                                    <el-tooltip effect="light" placement="top" content="视频上传"> <i
                                            class="el-icon-video-camera"></i></el-tooltip>

                                </el-upload>

                            </div>

                            <div class="txt">
                                <el-button type="primary" @click="submitEvent" icon="el-icon-s-promotion"></el-button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <el-drawer title="搜索结果" append-to-body :visible.sync="drawer" direction="rtl" :before-close="handleClose">
                <div v-for="(item, index) in drawerList" :key="index" class="drawer-item">
                    <div class="num">{{ index + 1 }}</div>
                    <div @click="openUrl(item)" style="cursor: pointer;"><i class="el-icon-paperclip"></i><span
                            style="font-size: 0.8rem;">打开链接</span></div>
                    <span class="titel" v-if="item.text">
                        {{ item.text }}</span>
                    <span class="titel" v-if="item.title">
                        {{ item.title }}</span><span v-if="item.snippet" class="snippet"
                        style="white-space: nowrap;overflow: hidden;">{{ item.snippet }}</span>

                    <!-- <a :href="item.url"
                    v-if="item.url">{{item.url}}</a> -->
                </div>
            </el-drawer>
            <el-image ref="imgRef" :z-index="999999" :preview-src-list="srcList">
            </el-image>
            <!-- 新增指令 -->
            <el-dialog :close-on-click-modal="false" append-to-body @close="close" :title="titleCommand" width="40%"
                class="dialogVisible" :visible.sync="commandShow">
                <div class="dialog-main">

                    <div class="dialog-main-item" style="flex-direction: column;align-items: flex-start;">
                        <div style="display: flex;flex-direction: column;text-align: left;"><span
                                class="name">指令标题</span>
                            <el-input v-model="commandObj.instructionsTitle" placeholder="请输入" />
                        </div>
                        <div style="display: flex;flex-direction: column;text-align: left;"><span
                                class="name">指令内容</span>
                            <el-input autosize type="textarea" v-model="commandObj.instructionsText" placeholder="请输入"
                                :rows="5" />
                        </div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="commandShow = false">取 消</el-button>
                    <el-button type="primary" @click="formSubmitCommand" style="margin-left: 1.25rem">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </el-dialog>
</template>

<script>
import { uploadFile } from '@/assets/js/oss';
import { fetchSSE, stopFetchSSE } from "@/api/sse";
import { chunkInit, chunkUpload } from '@/api/file/commonFile';
import TurndownService from 'turndown';
import { marked } from 'marked'
import hljs from "highlight.js";
import "highlight.js/styles/atom-one-dark.css";  // 选择合适的主题
import Clipboard from "clipboard";
import MarkdownIt from 'markdown-it';
import SparkMD5 from 'spark-md5';
import _ from "lodash";
import { generateSixDigitUUID } from '@/utils/utils';
import { chatList, chatRecords, delChatRecords, renameConversation, findQuestionAnswerConfigList, imageGenerateImage, textGenerateImage } from '@/api/questionAndAnswer';
import { addMyInstruction, delInstruction, updateMyInstruction, getMyInstructionList } from '@/api/command';
export default {
    name: "questionAndAnswer",
    components: {},
    data() {
        return {
            dialogVisible: true,
            titleCommand: "新增指令",
            commandObj: { userName: this.common.getCookie("loginName"), instructionsTitle: "", instructionsText: "" },
            commandShow: false,
            placeholder: "Talk to Bot",
            upHeightShow: false,
            suggestInfo: {},
            suggestShow: false,
            srcList: [],
            info: {},
            replayId: "",
            drawer: false,
            drawerList: [],
            problemList: [],
            list2: ["智能建造带来的影响？", "钢结构焊接温度要求？", "识别施工缺陷（如裂缝、钢筋裸露）并关联知识库解决方案？"],
            stopResp: false,
            dom: "",
            nextId: 0,
            textarea: "",
            loadding: false,
            loadding2: false,
            chatId: "",
            answerList: [],
            taskId: "",
            number: 0,
            configList: [],
            commandList: [],
            model: {
                online: false,
                knowledgeBase: false,
                chatId: "",
                userName: this.common.getCookie("loginName")

            },
            promptList: [],
            imgType: "",
            fileObj: {},
        };
    },
    computed: {
        currentPercent() {
            if (!this.fileObj.chunkCount) return 0;
            return Math.round(this.fileObj.currentChunk / this.fileObj.chunkCount * 100);
        },
    },
    created() {
        if (!this.common.getCookie("token")) {
            return
        }
        this.getChatList()
        this.getConfigList()
    },
    methods: {
        clearRecord(){
            this.suggestShow = false;
            this.placeholder = 'Talk to Bot'; 
            this.textarea = '';
            this.promptList = []; 
            this.imgType = '';
            this.clearFile();
        },
        handleInput(e, index) {
            this.$emit('input', e.target.textContent);
            this.promptList[index].value = e.target.innerText


        },
        openUrl(item) {
            window.open(item.url, "_blank")
        },
        formSubmitCommand() {
            switch (this.operateType) {
                case "add":
                    addMyInstruction(this.commandObj).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '新增成功!', duration: 500
                            });
                        }
                        this.commandShow = false;
                        this.getCommand()
                    });
                    break;
                case "edit":
                    updateMyInstruction(this.commandObj).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '修改成功!', duration: 500
                            });
                        } else {
                            this.$message.error("修改失败!");
                        }
                        this.commandShow = false;
                        this.getCommand()
                    });
                    break;
            }
        },
        delCommand(item) {
            this.$confirm('确定删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delInstruction(item.instructionsId).then(res => {
                    if (res.code == 200) {
                        this.getCommand()
                        this.$message({
                            type: 'success',
                            message: '删除成功!', duration: 1000
                        });
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除', duration: 1000
                });
            });
        },
        //新增指令
        addCommand() {
            this.titleCommand = "新增指令",
                this.operateType = "add"
            this.commandShow = true;
        },
        editCommand(item) {
            this.titleCommand = "修改指令",
                this.operateType = "edit";
            this.commandShow = true;
            this.commandObj = item;
        },
        //获取指令列表
        getCommand() {
            getMyInstructionList(this.common.getCookie("loginName")).then((res) => {
                this.commandList = res.data
            })
        },
        closeDialog() {
            this.$emit('close');
            this.commandShow = false;
        },
        close() {
            this.commandShow = false;
        },
        changeImg(item) {
            this.promptList = []
            this.promptList = item.prompt.split("{")
            this.promptList = this.promptList.map((item) => {
                if (item.indexOf("}") > -1) {
                    item = {
                        placeholder: item.split("}")[0],
                        str: item.split("}")[1],
                        value: "",
                    }
                } else {
                    item = {
                        placeholder: "",
                        str: item,

                    }
                }
                return item

            })
            this.placeholder = item.prompt
            this.imgType = item.type
        },
        changeSuggest(item) {
            this.suggestShow = true
            this.suggestInfo = item
            this.placeholder = item.prompt
            this.getCommand()
            this.$nextTick(() => {
                this.scrollBottom()
            })
        },
        //获取问答输入框提示语列表
        getConfigList() {
            findQuestionAnswerConfigList().then((res) => {
                if (res) {
                    this.configList = res.data
                }
            })
        },
        openVideo() {
            //播放视频
        },
        // rename
        rename(row) {
            this.replayId = row.chatId
            this.$nextTick(() => {
                console.log(this.$refs[row.chatId]);

                this.$refs[row.chatId][0].focus()
            })

        },
        // 上传文件
        handleFile(file) {
            if (file.name.split(".").pop().toLowerCase() != "docx" && file.name.split(".").pop().toLowerCase() != "doc") {
                this.$message.error("只能上传word文档！");

                return;
            }
            this.uploadFileBox(file, (res) => {
                this.info = {};
                this.info.fileName = res.fileName
                this.info.filePath = this.$severUrl(res.fileUrl);
                this.$forceUpdate();
            });
            // uploadFile(file.raw).then((res) => {
            //     if (res) {
            //         this.info.fileName = res.fileName
            //         this.info.filePath = this.$severUrl(res.fileUrl);
            //         this.$forceUpdate();
            //     }
            // });
        },
        //清楚文件
        clearFile() {
            this.info = {}
        },
        handleImg(file) {
            let fileType = file.name.split(".").pop().toLowerCase()
            if (fileType != "png" && fileType != "jpg" && fileType != "jpeg") {
                this.$message.error("只能上传png、jpg、jpeg等格式图片！");

                return;
            }
            // uploadFile(file.raw).then((res) => {
            //     if (res) {
            //         this.info.imgName = res.fileName
            //         this.info.imgPath = this.$severUrl(res.fileUrl);
            //         this.$forceUpdate();
            //     }
            // });
            this.uploadFileBox(file, (res) => {
                this.info = {};
                this.info.imgName = res.fileName;
                this.info.imgPath = this.$severUrl(res.fileUrl);
                this.$forceUpdate();
            });
        },
        handleVideo(file) {
            let fileType = file.name.split(".").pop().toLowerCase()
            if (fileType != "mp4") {
                this.$message.error("只能上传mp4格式文件！");

                return;
            }
            // uploadFile(file.raw).then((res) => {
            //     if (res) {
            //         this.info.videoName = res.fileName
            //         this.info.videoPath = this.$severUrl(res.fileUrl);
            //         this.$forceUpdate();
            //     }
            // });
            this.uploadFileBox(file, (res) => {
                this.info = {};
                this.info.videoName = res.fileName;
                this.info.videoPath = this.$severUrl(res.fileUrl);
                this.$forceUpdate();
            });
        },
        // 查看图片
        openImg(item) {
            if (item.imgPath) {
                this.srcList = [item.imgPath];
            }
            if (item.imgUrl) {
                this.srcList = [item.imgUrl];
            }
            if (item.rowImgUrl) {
                this.srcList = [item.rowImgUrl];
            }
            this.$nextTick(() => {
                this.$refs.imgRef.clickHandler();
            });
        },
        renameChat(row) {
            let obj = {
                "chatId": row.chatId,
                "newName": row.messageText,
                "userName": this.model.userName
            }
            renameConversation(obj).then(res => {
                if (res.code == 200) {
                    this.replayId = null
                }
            })
        },
        del(row) {
            this.$confirm('删除后，该对话将不可恢复。确认删除吗？', '永久删除对话', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delChatRecords({ chatId: row.chatId }).then(res => {
                    if (res.code == 200) {
                        this.getChatList()
                        this.$message({
                            type: 'success',
                            message: '删除成功!', duration: 500
                        });
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除', duration: 500
                });
            });
        },
        handleClose() {
            this.drawer = false
        },
        openDrawer(item) {
            this.drawer = true
            this.drawerList = item
        },
        refresh(index) {
            if (this.loadding2) {
                this.$message.info("请等待上条信息响应完成")
                return
            }
            this.textarea = this.answerList[index - 1].messageText
            this.submitEvent()

        },
        async copy(item) {
            // let clipboard = new Clipboard(".examSrc");
            // clipboard.on("success", () => {

            //     console.log('复制成功')
            //     // 释放内存
            //     clipboard.destroy();
            // });
            // clipboard.on("error", () => {

            //     clipboard.destroy();
            // });
            const turndownService = new TurndownService();
            const markdown = turndownService.turndown(item.messageText);
            // 3. 复制到剪贴板
            try {
                await navigator.clipboard.writeText(markdown);
                this.$msg({
                    showClose: true,
                    message: '复制成功',
                    type: "success",
                });
            } catch (err) {
                navigator.clipboard.writeText(item.messageText);
            }
        },
        onChangeClick(item) {
            if (!this.common.getCookie("token")) {

                this.$bus.emit("changeMsg", "222");
                return
            }
            this.active = item.name
        },
        addChat() {
            this.chatId = ""
            this.model.chatId = ""
            this.answerList = []
        },
        startAnswer(item) {
            this.textarea = item
            this.submitEvent("add")
        },
        // 获取对话列表
        getChatList(row) {
            chatList({ userName: this.model.userName }).then(res => {
                this.problemList = res.data
                if (!row) {
                    if (this.problemList && this.problemList.length > 0) {
                        this.changeChat(this.problemList[0])
                    }
                } else {
                    this.chatId = this.problemList[0].chatId
                    this.model.chatId = this.problemList[0].chatId
                }
            })
        },
        //切换对话
        changeChat(item) {
            this.chatId = item.chatId
            this.model.chatId = item.chatId
            chatRecords({ chatId: item.chatId }).then(res => {
                this.answerList = res.data
                this.answerList.forEach((item, index) => {
                    item.id = index + 1
                    if (item.user != "ai") {
                        item.role = "user"
                        if (item.imgUrl) {
                            item.imgName = item.imgUrl.split(".").pop()
                            item.imgPath = item.imgUrl
                        }
                        if (item.fileUrl) {
                            item.fileName = item.fileUrl.split(".").pop()
                        }
                        if (item.videoUrl) {
                            item.videoName = item.videoUrl.split(".").pop()
                        }
                    } else {
                        item.messageText = marked.parse(item.messageText);
                        item.role = "assistant"
                    }
                })
                this.$nextTick(() => {
                    this.scrollBottom()
                })
            })
        },
        submitEvent(row) {
            if (!this.common.getCookie("token")) {
                this.$bus.emit("changeMsg", "222");
                return
            }
            console.log(this.promptList);
            if (this.promptList.length > 1) {
                this.promptList.map(item => {
                    let str = ""
                    if (item.placeholder) {
                        str = item.value + item.str
                    } else {
                        str = item.str
                    }
                    this.textarea += str
                })
            }
            if (!this.textarea) {
                this.$message.info("提问不能为空！")
                return
            }
            if (this.loadding2) {

                this.$message.info("请等待上条信息响应完成！")
                return
            }

            if (this.suggestShow && !this.info.filePath && this.suggestInfo.type == "2") {
                this.$message.info("请上传文档！")
                return
            }
            if (this.suggestShow && !this.info.imgPath && this.suggestInfo.type == "3" && this.imgType != "3.1") {
                this.$message.info("请上传参考图片！")
                return
            }
            this.loadding = true
            this.loadding2 = true
            this.nextId = this.answerList.length
            this.nextId++
            this.number = 0
            this.model.filePath = this.info.filePath
            this.model.imgPath = this.info.imgPath
            this.model.videoPath = this.info.videoPath

            this.answerList.push({ messageText: this.textarea, role: "user", id: this.nextId, fileName: this.info.fileName, imgName: this.info.imgName, imgPath: this.info.imgPath, videoName: this.info.videoName, videoPath: this.info.videoPath, "isStreaming": false })
            this.info = {}
            this.promptList = []
            this.suggestShow = false
            this.placeholder = "Talk to Bot"
            this.nextId++
            this.answerList.push({ messageText: "", role: "assistant", id: this.nextId, "isStreaming": false })
            this.dom = this.$refs.Dialogue;
            this.$nextTick(() => {
                this.scrollBottom()
            })
            let content = this.textarea
            this.model.prompt = this.textarea
            this.textarea = ""
            this.stopResp = true
            this.model.chatId = this.chatId
            let sclosss = ""
            if (this.imgType == "3.2") {
                imageGenerateImage(this.model.imgPath, this.model.prompt).then(res => {
                    this.loadding = false
                    this.loadding2 = false
                    this.stopResp = false
                    // this.answerList[this.nextId - 1].messageText = `<img style="width:10rem" src=${res.msg} alt="">`
                    this.answerList[this.nextId - 1].rowImgUrl = res.msg
                })
                return
            }
            if (this.imgType == "3.1") {
                textGenerateImage(this.model.prompt).then(res => {
                    this.loadding = false
                    this.loadding2 = false
                    this.stopResp = false
                    // this.answerList[this.nextId - 1].messageText = `<img style="width:3rem" src=${res.msg} alt="">`
                    this.answerList[this.nextId - 1].rowImgUrl = res.msg
                })
                return
            }
            fetchSSE(`/api/ai/vllm/chat`, this.model, (chunk) => {
                this.loadding = false;
                let jsonString = "";
                this.imgType = '';
                if(chunk=='request_error'){
                    this.loadding2 = false
                    this.answerList[this.nextId - 1].messageText='request_error';
                    return
                };
                chunk = chunk.split("data:").filter(item => item);
                if (chunk && typeof chunk != 'string' && chunk.length > 0) {
                    chunk.map(item => {
                        if (item.includes("SEARCHING") || item.includes("KNOWLEDGEBASE")) {
                            this.answerList[this.nextId - 1].vectorResults = JSON.parse(item)["KNOWLEDGEBASE"]
                            this.answerList[this.nextId - 1].webResults = JSON.parse(item)["SEARCHING"]
                        }
                        if (item.includes("{") && !item.includes("SEARCHING") && !item.includes("KNOWLEDGEBASE")) {
                            item = item.trim()
                            item = JSON.parse(item)
                            jsonString += item["key"].replace(/\\n/g, '\n')
                        }
                    })
                }
                this.scrollBottom()
                sclosss += jsonString
                if (jsonString.includes("CLOSE_CONNECTION")) {
                    this.loadding2 = false
                    if (row) {
                        this.getChatList("add")
                    }
                    sclosss = sclosss.split("CLOSE_CONNECTION")[0]
                    this.stopResp = false
                    this.answerList[this.nextId - 1].messageText = marked.parse(sclosss)
                    return
                }
                this.answerList[this.nextId - 1].messageText = marked.parse(sclosss)
                // 重新高亮代码块
                document.querySelectorAll('pre code').forEach((block) => {
                    hljs.highlightBlock(block);
                });
            })
        },

        scrollBottom() {
            this.dom = this.$refs.Dialogue;
            if (!this.dom) return;
            let scrollTop = this.dom.scrollTop;
            // 变量windowHeight是可视区的高度
            let windowHeight = this.dom.clientHeight || this.dom.clientHeight;
            // 变量scrollHeight是滚动条的总高度
            let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight;


            if (scrollHeight + 40 > windowHeight + scrollTop) {

                this.dom.scrollTop = scrollHeight - windowHeight + 50

                console.log(this.dom.scrollTop, "+ 40");

            }
        },
        toDown() {
            this.scrollBottom()

        },
        stopAnswer() {
            stopFetchSSE()
            this.stopResp = false
        },
        async uploadFileBox(e, callback) {
            var file = e.raw;
            if (file.size > 5 * 1024 * 1024 * 1024) {
                this.$msg({
                    showClose: true,
                    message: "上传文件大小不得超过5G",
                    type: "error",
                });
                return;
            }
            let obj = new Object();
            obj.chunkSize = 1024 * 1024 * 5;
            obj.currentChunk = 0;
            obj.md5 = '';
            obj.initFileData = new Object();
            obj.file = file;
            obj.fileName = '';
            obj.isStop = false;
            obj.status = '';
            obj.chunkCount = Math.ceil(file.size / obj.chunkSize)
            this.fileObj = obj;
            if (obj.file.size < 10 * 1024 * 1024) {
                uploadFile(obj.file, true).then((res) => {
                    if (res) {
                        obj.status = 'success';
                        this.$msg({
                            showClose: true,
                            message: "上传成功",
                            type: "success",
                        });
                        obj.id = res.id;
                        obj.fileName = res.fileName;
                        obj.response = res;
                        typeof callback == 'function' && callback(res);
                        return;
                    }
                }).catch(() => {
                    this.fileObj = {};
                });
                return;
            }
            obj.status = 'pending';
            await this.fileMd5Sum(obj);
            await this.initUpload(obj);
            if (obj.initFileData.secondUpload) {
                obj.fileName = obj.initFileData.fileName;
                obj.id = obj.initFileData.id;
                obj.status = 'success';
                this.$msg({
                    showClose: true,
                    message: "上传成功",
                    type: "success",
                });
                typeof callback == 'function' && callback(obj.initFileData);
                return;
            }
            this.loadingUpload(obj, callback);
        },
        uploadChunk(item, index) {
            // 计算分片的起始和结束字节
            let start = (index - 1) * item.chunkSize;
            let end = Math.min(item.file.size, start + item.chunkSize);
            // 将分片读取为Blob
            let chunk = item.file.slice(start, end);
            // 创建FormData并附加分片
            let formData = new FormData();
            formData.append('chunkNumber', index);
            formData.append('chunkSize', end - start);
            formData.append('file', chunk);
            formData.append('fileExt', item.initFileData.fileExt);
            formData.append('fileKey', item.initFileData.fileKey);
            formData.append('fileName', item.file.name);
            formData.append('fileSearch', item.initFileData.fileSearch);
            formData.append('fileSize', item.file.size);
            formData.append('md5', item.initFileData.md5);
            formData.append('secondUpload', item.initFileData.secondUpload);
            formData.append('totalChunks', item.chunkCount);
            formData.append('uploadId', item.initFileData.uploadId);
            return formData
        },
        loadingUpload(item, callback, i = item.currentChunk + 1) {
            let params = this.uploadChunk(item, i);
            chunkUpload(params).then(res => {
                item.currentChunk = i;
                if (item.isStop) return;
                i++;
                if (item.currentChunk >= item.chunkCount) {
                    this.$msg({
                        showClose: true,
                        message: "上传成功",
                        type: "success",
                    });
                    item.fileName = res.data.fileName;
                    item.id = res.data.id;
                    item.status = 'success';
                    item.response = res.data;
                    typeof callback == 'function' && callback(res.data);
                    return;
                }
                this.loadingUpload(item, callback, i);
            }).catch(() => {
                // var index1 = fileArr.findIndex(e => e.md5 == item.md5);
                // if (index1 != -1) {
                //     fileArr.splice(index1, 1);
                // }
                this.fileObj = {};
            })
        },
        initUpload(obj) {
            return new Promise((resolve) => {
                var params = {
                    "fileName": obj.file.name,
                    "fileSearch": true,
                    "fileSize": obj.file.size,
                    "md5": obj.md5
                };
                chunkInit(params).then(res => {
                    if (res.code == 200) {
                        obj.initFileData = res.data;
                        obj.response = res.data;
                        if (res.data.chunkDataList && res.data.chunkDataList.length > 0) {
                            obj.currentChunk = res.data.chunkDataList.length;
                        }
                        resolve(res);
                    }
                }).catch(() => {
                    this.fileObj = {};
                });
            })
        },
        fileMd5Sum(item) {
            return new Promise(async (resolve, reject) => {
                let file = item.file;
                let chunkSize = 5 * 1024 * 1024;
                const spark = new SparkMD5.ArrayBuffer();
                const fileReader = new FileReader();
                const chunks = Math.ceil(file.size / chunkSize);
                let currentChunk = 0;
                fileReader.onload = (e) => {
                    spark.append(e.target.result); // 添加当前 chunk 数据
                    if (chunks <= 10) {
                        currentChunk++;
                    } else if (chunks > 10 && chunks <= 30) {
                        currentChunk = currentChunk + 3;
                    } else {
                        currentChunk = currentChunk + 5;
                    }
                    if (currentChunk < chunks) {
                        loadNextChunk(); // 继续读取下一块
                    } else {
                        const md5 = generateSixDigitUUID() || spark.end();
                        item.md5 = generateSixDigitUUID() || md5;
                        resolve(md5);
                    }
                };

                fileReader.onerror = () => {
                    reject(new Error("文件读取失败"));
                };

                function loadNextChunk() {
                    const start = currentChunk * chunkSize;
                    const end = Math.min(start + chunkSize, file.size);
                    const chunk = file.slice(start, end); // 切割文件块
                    fileReader.readAsArrayBuffer(chunk); // 读取当前块
                }
                loadNextChunk(); // 开始读取第一个块
            })
        }
    },
    mounted() {
        marked.setOptions(
            {
                highlight: function (code, lang) {
                    const language = hljs.getLanguage(lang) ? lang : 'plaintext';
                    return hljs.highlight(code, { language }).value;
                },
                breaks: true,
                gfm: true,
                // 启用 GitHub Flavored Markdown（表格、任务列表等）
                headerIds: false, // 禁用自动生成标题 ID（如 <h1 id="hello-markedjs">）
                silent: false,     // 不输出解析错误（默认 false，遇到错误会抛出）
            });

        //
        this.dom = this.$refs.Dialogue;
        if (this.dom) {
            this.dom.addEventListener("scroll", () => {
                // 滚动距离
                let scrollTop = this.dom.scrollTop;
                // 变量windowHeight是可视区的高度
                let windowHeight = this.dom.clientHeight || this.dom.clientHeight;
                // 变量scrollHeight是滚动条的总高度
                let scrollHeight = this.dom.scrollHeight || this.dom.scrollHeight;
                // console.log(scrollTop, windowHeight, scrollHeight, 55656);
                if (scrollTop + windowHeight + 5 < scrollHeight) {

                    this.upHeightShow = true

                } else {
                    this.upHeightShow = false
                }
            });
        }

    },

    watch: {

    },
};
</script>

<style scoped lang="less">
@import "../../assets/css/globalCard.less";
@import "../../assets/css/aiCommon.less";

.main {
    overflow: hidden;
}

.think-type {
    left: 10px;
    position: absolute;
    bottom: 5px;

    /deep/ .el-button {
        border-radius: 20px;
    }

    /* .el-button--primary {
            color: #5a48f5;
            background-color: rgb(226, 230, 241);
            border-color: #5a48f5;
        }

        .el-button--primary:focus,
        .el-button--primary:hover {
            color: #5a48f5;
            background-color: rgb(226, 230, 241);
            border-color: #5a48f5;
        }
        .el-button:hover, .el-button:focus{
            color: #5a48f5;
            background-color: rgb(226, 230, 241);
            border-color: #5a48f5;
        } */
}

.think-type2 {
    display: flex;
    right: 90px;
    position: absolute;
    bottom: 5px;

    i {
        font-size: 24px;
        margin-left: 15px;
        cursor: pointer;
    }

    i:hover {
        color: #5a48f5;
    }
}

ol {
    list-style-type: decimal !important;

}

/* 知识库 */
.known {
    cursor: pointer;
    text-align: left;
    padding-left: 1rem;
    margin-bottom: 1rem;
    color: var(--blue);
    border-radius: 1rem;
    width: 15rem;
    height: 3rem;
    font-size: 12px;
    white-space: nowrap;
    line-height: 3rem;
    background-color: rgb(237, 237, 237);
}

.drawer-item {
    position: relative;
    margin: 0 20px;
    display: flex;
    /* background-color: #ccc; */
    flex-direction: column;
    margin-bottom: 10px;

    .titel {
        font-weight: 700;
        font-size: 16px;
    }

    .snippet {
        color: #aaa;
        font-size: 14px;
        min-width: 300px;
        height: 40px;
    }

    .num {

        top: 0;
        right: 0;
        text-align: center;
        line-height: 20px;
        width: 20px;
        height: 20px;
        position: absolute;
        border-radius: 50%;
        background-color: #eee;
    }
}



.visible-chat {
    display: flex !important;
}

.no-display {
    display: none;
}

.item-del {
    z-index: 1000;
    position: absolute;
    left: 220px;
    top: 180px;
    width: 100px;
    height: 60px;
    background-color: #fff;
    box-shadow: 1px 1px 1px 1px #ccc;

}

.add-item:hover {
    display: flex !important;

    .el-dropdown {
        display: flex !important;
    }

}

/* /deep/ .el-textarea__inner {
        font-size: 16px;
        min-height: 50px !important;
    } */

.file {
    padding: 0 10px;
    padding-top: 5px;
    transition: #ccc 0.1s ease-out;

    img {
        width: 50px;
        height: 50px;
    }
}

.file:hover {
    /* box-shadow: 0px 0px 0px .5px #ccc, 0px 4px 8px 0px rgba(144, 150, 174, .25); */
    background-color: rgba(96, 98, 102, 0.1);
}

.upHeightShow {
    cursor: pointer;
    position: absolute;
    z-index: 10000;
    top: -40px;
    right: 10px;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #f2f5f6;
    box-shadow: 0 0 6px rgba(0, 0, 0, .12);
    text-align: center;
    line-height: 32px;
    /* color: #1989fa; */
    font-weight: 700;
    color: #000;
    font-size: 20px;

}

.upHeightShow:hover {
    background: #eee;
}

.Questions-suggest {
    border-bottom: 1px solid #ccc;
    height: 40px;
    display: flex;
    font-size: 14px;
    align-items: center;


    div {
        cursor: pointer;
        margin-left: 15px;

        i {
            padding-right: 5px;
        }
    }
}

.Questions-suggest-detail {
    color: #000;
    border-bottom: 1px solid #ccc;
    height: 114px;
    box-sizing: border-box;

    .suggest-detail-title {
        padding: 10px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;


    }

    .suggest-content {
        display: flex;
        padding: 0 10px;

        .suggest-item {
            margin-left: 10px;
            border: 1px solid #ccc;
            width: 120px;
            height: 50px;
            font-size: 16px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            i {
                margin-right: 5px;
                font-size: 16px;
                color: #5a48f5;
            }
        }

        .suggest-item:hover {
            border: 1px solid #5a48f5;
        }

        .suggest-item-active {
            border: 1px solid #5a48f5;
        }
    }
}

.height-active {
    height: calc(100% - 200px) !important;
}

.el-card {
    border-radius: 20px;
    color: rgb(29, 34, 52);
}

/deep/.el-card__body {
    padding: 0 !important;

    .el-main {
        padding: 0 !important;
    }
}

.auto-width-input {
    display: inline-block;

    /* padding: 0 15px; */
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    outline: none;
    min-width: 60px;
}

.auto-width-input:focus {
    border-color: #409eff;
}

.auto-width-input:empty::before {
    content: attr(data-placeholder);
    color: #c0c4cc;
    pointer-events: none;
    display: block;
    /* 确保占位符显示 */
}

.textarea-suggestShow {
    padding-left: 20px;
    min-height: 60px;
}

/deep/.el-dialog__body {
    padding-top: 0 !important;
}

/deep/.el-textarea__inner {
    height: 7rem !important;
}

/deep/.el-dialog {
    border-radius: 2rem;
}

/deep/ li {
    margin-left: 2rem;
}

/deep/ol {
    padding-left: 0 !important;
}

.btn-button {
    background-color: rgb(226, 230, 241);
    color: rgb(77, 107, 254);
    cursor: pointer;
    padding: 1rem;
    display: inline-block;
    border-radius: 1rem;
    margin-top: 1rem;
}

/* 隐藏所有滚动条（滑块+轨道） */
.scroll-box::-webkit-scrollbar-thumb {
    background-color: transparent !important;
    /* 滑块透明 */
}

.scroll-box::-webkit-scrollbar-track {
    background-color: transparent !important;
    /* 轨道透明 */
}
</style>